// extracted by mini-css-extract-plugin
export default {"root":"PreCheckoutConfirmModal_root__RW5Ml","confirmationText":"PreCheckoutConfirmModal_confirmationText__kVEcW"};